import { Switch as ChakraSwitch } from '@chakra-ui/react';
import { forwardRef, useRef } from 'react';

import { createSyntheticChangeEvent } from '../../../utils';
import { SwitchDefaultProps, type SwitchProps } from './Switch.types';

const Switch = forwardRef<HTMLInputElement, SwitchProps>(({ checked, onChange, ...props }, ref) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleCheckedChange = (event: { checked: boolean }) => {
    if (onChange) {
      const syntheticEvent = createSyntheticChangeEvent(
        inputRef.current,
        String(event.checked),
        event.checked
      );
      onChange(syntheticEvent);
    }
  };

  return (
    <ChakraSwitch.Root checked={checked} onCheckedChange={handleCheckedChange} {...props}>
      <ChakraSwitch.HiddenInput ref={ref ?? inputRef} />
      <ChakraSwitch.Control>
        <ChakraSwitch.Thumb />
      </ChakraSwitch.Control>
      <ChakraSwitch.Label />
    </ChakraSwitch.Root>
  );
});

Switch.displayName = 'Switch';
Switch.defaultProps = SwitchDefaultProps;

export { Switch };
